<div *ngIf="currentLayout != 'l_banner'">
    <div class="col-sm-12">
        <div class="form-group">
            <label for="basedOnData">Based on Data</label>
            <ccl-simple-select formId="basedOnData"
                [listOfItems]="basedOnDatas"
                (valueChange)="imageConfig.basedOn = $event.value"
                [value]="imageConfig.basedOn"
                [bindValue]="'code'"
                [bindLabel]="'label'"
                [isClearable]="false"
            ></ccl-simple-select>
        </div>
    </div>
</div>
<div
    class="row"
    *ngIf="(currentLayout == 'l_circular' || currentLayout == 'l_square') && imageConfig.basedOn === 'speaker_img'"
>
    <div class="col-sm-12">
        <div class="image-example">
            <span> Image Example </span> <br />
            <img alt="Image Example"
                src="assets/images/blank_profile.jpg"
                [ngStyle]="{
                    height: imageConfig.height,
                    width: imageConfig.width,
                    'background-color': imageConfig.background,
                    margin: imageConfig.margin,
                    'border-radius': currentLayout == 'l_circular' ? imageConfig.height : '0px'
                }"
            />
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayWidth">Display Width</label></div>
            <input id="displayWidth"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.width"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayHeight">Display Height</label></div>
            <input id="displayHeight"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.height"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="margin">Region Margin</label></div>
            <input id="margin"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlay">Image overlay Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlay"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="row" *ngIf="currentLayout == 'l_banner'">
    <div class="col-sm-12">
        <ccl-image-upload
            (imageChange)="imageChange($event)"
            (uploadEvent)="uploadEvent($event)"
            [image]="imageConfig.banner"
        ></ccl-image-upload>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="margin2">Region Margin</label></div>
            <input id="margin2"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlay2">Image overlay Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlay2"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="row" *ngIf="imageConfig.basedOn === 'dynamic_img' && currentLayout != 'l_banner'">
    <div class="col-sm-12">
        <ccl-image-upload
            (imageChange)="imageChange($event)"
            (uploadEvent)="uploadEvent($event)"
            [image]="imageConfig.dynamicImage"
        ></ccl-image-upload>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayWidth3">Display Width</label></div>
            <input id="displayWidth3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.width"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayHeight3">Display Height</label></div>
            <input id="displayHeight3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.height"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="margin3">Region Margin</label></div>
            <input id="margin3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlay3">Image overlay Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlay3"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
